import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import ClientsPage from "./dashboard/pages/ClientsPage"
import InvoicesPage from './dashboard/pages/InvoicesPage';
import PaymentsPage from './dashboard/pages/PaymentsPage';
import ItemServicesPage from './dashboard/pages/ItemServicespage';
import DashboardPage from './dashboard/pages/DashboardPage';
import VendorsPage from './dashboard/pages/VendorsPage';
import PurchasesPage from './dashboard/pages/PurchasesPage';
import DamageControlPage from './dashboard/pages/DamageControlPage';
import DeliverynotePage from './dashboard/pages/DeliverynotePage';
import ProductsPage from './dashboard/pages/ProductsPage';
import ChequesPage from './dashboard/pages/ChequesPage';
import RegisterPage from './dashboard/pages/RegisterPage';
import LoginPage from './web/pages/LoginPage';
import AccountsPage from './dashboard/pages/AccountsPage';
import VendorPaymentsPage from './dashboard/pages/VendorPaymentsPage';
import VendorAccountsPage from './dashboard/pages/VendorAccountsPage';
import SalesmanPage from './dashboard/pages/SalesmanPage';
import SalesReturnPage from './dashboard/pages/SalesReturnPage';
import SalesQuotationPage from './dashboard/pages/SalesQuotationPage';
import PurchaseOrderPage from './dashboard/pages/PurchaseOrderPage';
import Notfound from './web/pages/Notfound';

import WebLayout from './web/web-layout';
import DashLayout from './dashboard/dash-layout';
import PurchaseReturnPage from './dashboard/pages/PurchaseReturnPage';
import CreditnotePage from './dashboard/pages/CreditnotePage';
import DebitnotePage from './dashboard/pages/DebitnotePage';
import ItemProductsReportPage from './dashboard/pages/ItemProductsReportPage';
import PaymentsReportPage from './dashboard/pages/PaymentsReportPage';
import InventoryReportsPage from './dashboard/pages/InventoryReportsPage';
import CategoryItem from './dashboard/pages/CategoryItem';
import SalesReportPage from './dashboard/pages/SalesReportPage';
import PurchaseExpenseReportsPage from './dashboard/pages/PurchaseExpenseReportsPage';
import DamageControlReportsPage from './dashboard/pages/DamageControlReportsPage';
import ReportItemSales from './dashboard/pages/ReportItemSales';
import { ImageProvider } from './dashboard/context/ImageContext';

function App() {
  return (
    <>
    <ImageProvider>
    <Router>
        <Routes>

          <Route path='/' element={<WebLayout />}>
            <Route index element={<LoginPage />} />
          </Route>

          <Route path='/dashboard' element={<DashLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="invoices" element={<InvoicesPage />} />
            <Route path="client_payments" element={<PaymentsPage />} />
            <Route path="vendor_payments" element={<VendorPaymentsPage />} />
            <Route path="cheques" element={<ChequesPage />} />
            <Route path="item-services" element={<ItemServicesPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="item-category" element={<CategoryItem />} />
            <Route path="vendors" element={<VendorsPage />} />
            <Route path="purchases" element={<PurchasesPage />} />
            <Route path="damagecontrol" element={<DamageControlPage />} />
            <Route path="delivery-notes" element={<DeliverynotePage />} />
            <Route path="client_accounts" element={<AccountsPage />} />
            <Route path="salesman" element={<SalesmanPage />} />
            <Route path="sales_return" element={<SalesReturnPage />} />
            <Route path="sales_qoutation" element={<SalesQuotationPage />} />
            <Route path="purchase_order" element={<PurchaseOrderPage />} />
            <Route path="vendor_accounts" element={<VendorAccountsPage />} />
            <Route path="purchase_return" element={<PurchaseReturnPage />} />
            <Route path="credit_note" element={<CreditnotePage />} />
            <Route path="debit_note" element={<DebitnotePage />} />
            <Route path="item_p_reports" element={<ItemProductsReportPage />} />
            <Route path="payments_report" element={<PaymentsReportPage />} />
            <Route path="inventory_reports" element={<InventoryReportsPage />} />
            <Route path="sales_reports" element={<SalesReportPage />} />
            <Route path="item_sales" element={<ReportItemSales />} />
            <Route path="purchase_expense_reports" element={<PurchaseExpenseReportsPage />} />
            <Route path="damage_reports" element={<DamageControlReportsPage />} />
          </Route>

          <Route path="*" element={<Notfound />} />

        </Routes>
      </Router >
    </ImageProvider>
    </>
  );
}

export default App;
